import React from 'react';
import { Box, Grid, Skeleton, useMediaQuery, useTheme } from '@mui/material';

// Szary placeholder o kształcie AttendanceCardComponent, wyświetlany podczas ładowania danych z serwera
function AttendanceCardSkeleton() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container spacing={isMobile ? 1 : 0}
            sx={{
                justifyContent: "center",
                alignItems: isMobile ? 'stretch' : 'flex-start',
                mb: '15px',
                p: isMobile ? 1.5 : 0,
                border: isMobile ? '1px solid rgba(0,0,0,0.08)' : 'none',
                borderRadius: '8px',
            }}>

            {/* Imię, nazwisko, status */}
            <Grid size={{ xs: 12, sm: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <Box sx={{ ml: 2, minWidth: 0 }}>
                        <Skeleton variant="text" width={110} height={28} />
                        <Skeleton variant="rounded" width={80} height={18} sx={{ mt: 0.5 }} />
                    </Box>
                </Box>
            </Grid>

            {/* Kamera */}
            <Grid size={{ xs: 12, sm: 0.5 }} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-start' : 'center' }}>
                <Skeleton variant="circular" width={24} height={24} />
            </Grid>

            {/* Oś czasu */}
            <Grid size={{ xs: 12, sm: 6 }}>
                <Skeleton variant="rounded" width="100%" height={24} sx={{ mt: isMobile ? 1 : 1.5 }} />
            </Grid>

            {/* Godziny i daty */}
            <Grid size={{ xs: 12, sm: 1.5 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'flex-start' : 'center', ml: isMobile ? 0 : 2 }}>
                    <Skeleton variant="text" width={90} height={20} />
                    <Skeleton variant="text" width={90} height={20} />
                </Box>
            </Grid>

            {/* Przepracowany czas */}
            <Grid size={{ xs: 6, sm: 1 }} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-start' : 'center' }}>
                <Skeleton variant="text" width={50} height={28} />
            </Grid>

            {/* Akcje */}
            <Grid size={{ xs: 3, sm: 0.5 }} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-end' : 'center' }}>
                <Skeleton variant="circular" width={24} height={24} />
            </Grid>
            <Grid size={{ xs: 3, sm: 0.5 }} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-end' : 'center' }}>
                <Skeleton variant="circular" width={24} height={24} />
            </Grid>
        </Grid>
    );
}

export default AttendanceCardSkeleton;
